import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '@/configuration/setup/store';

interface AppState {
    readinessNotified: boolean;
}

const initialState: AppState = {
    readinessNotified: false,
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        readinessNotified: (state) => {
            state.readinessNotified = true;
        },
    },
});

export const { readinessNotified } = appSlice.actions;

export const isReadinessNotifiedSelector = (state: RootState) => state.app.readinessNotified;

export default appSlice.reducer;
